// apps/web/src/features/cargo/components/CargoDeleteConfirm.tsx
//
// Soft-delete confirmation (#1232). The dialog SHOWS the article string before
// the destructive call so the actor confirms exactly which row they remove.

import { useTranslation } from 'react-i18next';
import type { CargoArticleWire } from '@magimp/shared';

import { ConfirmModal } from '../../../ui/index.js';
import { useToastStore } from '../../../stores/toast.js';
import { errorMessage } from '../../../api/errors.js';
import { useDeleteCargo } from '../mutations.js';

export interface CargoDeleteConfirmProps {
  row: CargoArticleWire;
  onClose: () => void;
}

export function CargoDeleteConfirm({ row, onClose }: CargoDeleteConfirmProps) {
  const { t } = useTranslation(['cargo', 'common']);
  const showToast = useToastStore((s) => s.show);
  const del = useDeleteCargo();

  function onConfirm() {
    del.mutate(row.id, {
      onSuccess: () => showToast({ tone: 'success', text: t('cargo:delete.toast') }),
      onError: (err) => showToast({ tone: 'error', text: errorMessage(err) }),
    });
  }

  return (
    <ConfirmModal
      title={t('cargo:delete.title')}
      text={t('cargo:delete.text', { article: row.article })}
      danger
      confirmLabel={t('common:actions.delete')}
      onConfirm={onConfirm}
      onClose={onClose}
    />
  );
}
